// pages/Dashboard.jsx
import BookSuggestionForm from "../../components/home/BookSuggestionForm";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <BookSuggestionForm />
    </HomeLayout>
  );
}
